import React, { useState } from 'react';

import { useDispatch, useSelector } from '../store/hooks';
import { downloadLeasesAsCSV, downloadSalesAsCSV, retrieveLeases, retrieveSales } from '../store/actions/search';
import { getNewCompReportPath } from '../store/selectors/paths';
import { getSelectedIds } from '../store/selectors/select_list';
import { canExport, getCurrentTab } from '../store/selectors/ui';

import Button from 'shared/button';
import CompsImportModal from 'bundles/crm/imports/comps';
import Dropdown from 'components/dropdown';

export default function CompsHeaderControls() {
  const canExportData = useSelector(canExport);
  const currentTab = useSelector(getCurrentTab);
  const importerProps = useSelector(state => state.importerProps);
  const newCompReportPath = useSelector(getNewCompReportPath);
  const selectedIds = useSelector(getSelectedIds) as number[];
  const canImport = useSelector(state => state.features.edgeCrm);
  const dispatch = useDispatch();

  const [showImportModal, setShowImportModal] = useState(false);

  let importExportControl;
  const downloadActionCreator = currentTab === 'lease' ? downloadLeasesAsCSV : downloadSalesAsCSV;
  const onImportHide = (refresh) => {
    if (refresh) {
      dispatch(currentTab === 'lease' ? retrieveLeases() : retrieveSales());
    }
    setShowImportModal(false);
  };

  if (canImport && canExportData && importerProps) {
    importExportControl = (
      <Dropdown
        align="start"
        label="Actions"
        variant="outline"
      >
        <Dropdown.Item label="Import Comps" onClick={() => setShowImportModal(true)} />
        <Dropdown.Item label="Export as CSV" onClick={() => dispatch(downloadActionCreator())} />
      </Dropdown>
    );
  } else if (canExportData) {
    importExportControl = (
      <Button.Accent onClick={() => dispatch(downloadActionCreator())}>
        Export as CSV
      </Button.Accent>
    );
  } else if (canImport && importerProps) {
    importExportControl = (
      <Button.Accent outlined onClick={() => setShowImportModal(true)}>
        Import Comps
      </Button.Accent>
    );
  }

  let newReportControl;
  if (newCompReportPath) {
    const disabled = selectedIds.length === 0;
    newReportControl = (
      <Button.Primary
        disabled={disabled}
        disabledTooltip="Select comps to create a report"
        href={disabled ? undefined : `${newCompReportPath}?type=${currentTab}&comp_ids=${selectedIds}`}
        label="Create a Report"
      />
    );
  }

  return <>
    {importExportControl}
    {newReportControl}
    {canImport && importerProps && (
      <CompsImportModal
        {...importerProps}
        show={showImportModal}
        onHide={onImportHide}
      />
    )}
  </>;
};
